// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nq-c";
export var backButton = "_nq-4";
export var backIcon = "_nq-5";
export var chevronShortcut = "_nq-6";
export var container = "_nq-1";
export var editor = "_nq-8";
export var editorWrapper = "_nq-7";
export var prefix = "_nq-2";
export var searchIcon = "_nq-3";
export var suffix = "_nq-9";
export var suffixContent = "_nq-a";
export var suffixText = "_nq-b";
export var wrapper = "_nq-0";